import { render, staticRenderFns } from "./CompanyCopyConfig.vue?vue&type=template&id=7cb39021&"
import script from "./CompanyCopyConfig.vue?vue&type=script&lang=js&"
export * from "./CompanyCopyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports